var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container processSensory" },
    [
      _c(
        "el-row",
        { staticStyle: { margin: "20px 0 20px 0" } },
        [
          !_vm.disabled && ["edit", "change"].includes(_vm.$route.query.type)
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.PROC_LOT_RECORD_ADD,
                      expression: "PROC_LOT_RECORD_ADD",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("visitPlan.draftSave")))]
              )
            : _vm._e(),
          !_vm.disabled &&
          !_vm.needUpdateReason &&
          ["edit", "change"].includes(_vm.$route.query.type)
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.PROC_LOT_RECORD_ADD,
                      expression: "PROC_LOT_RECORD_ADD",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.submit")))]
              )
            : _vm._e(),
          !_vm.disabled &&
          _vm.needUpdateReason &&
          ["edit", "change"].includes(_vm.$route.query.type)
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.PROC_LOT_RECORD_ADD,
                      expression: "PROC_LOT_RECORD_ADD",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.changeSubmit()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.submit")))]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "processSensoryReportList" })
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.close")))]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.firstHandleClick },
          model: {
            value: _vm.firstActiveName,
            callback: function ($$v) {
              _vm.firstActiveName = $$v
            },
            expression: "firstActiveName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "基础信息", name: "basicInfo" } },
            [
              _c(
                "el-form",
                {
                  ref: "report",
                  attrs: { model: _vm.report, "label-width": "150px" },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单据编号" } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.report.reportNo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.report, "reportNo", $$v)
                                  },
                                  expression: "report.reportNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "版本" } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.report.version,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.report, "version", $$v)
                                  },
                                  expression: "report.version",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "产品", prop: "fiveBitCodeName" },
                            },
                            [
                              _vm.report.fiveBitCodeName &&
                              _vm.report.fiveBitCodeName.length > 13
                                ? _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.report.fiveBitCodeName,
                                        placement: "top-start",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "handle-input",
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.report.fiveBitCodeName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.report,
                                              "fiveBitCodeName",
                                              $$v
                                            )
                                          },
                                          expression: "report.fiveBitCodeName",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("el-input", {
                                    staticClass: "handle-input",
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.report.fiveBitCodeName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.report,
                                          "fiveBitCodeName",
                                          $$v
                                        )
                                      },
                                      expression: "report.fiveBitCodeName",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Facility编号" } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.report.supplierCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.report, "supplierCode", $$v)
                                  },
                                  expression: "report.supplierCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Facility名称" } },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.report.plantName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.report, "plantName", $$v)
                                  },
                                  expression: "report.plantName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "评估人", prop: "rater" } },
                            [
                              _c(
                                "el-input",
                                {
                                  staticClass: "handle-input",
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.report.rater,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.report, "rater", $$v)
                                    },
                                    expression: "report.rater",
                                  },
                                },
                                [
                                  _vm.report.raterQualified == "Y"
                                    ? _c("i", {
                                        staticClass: "el-icon-success",
                                        staticStyle: { color: "green" },
                                        attrs: { slot: "append" },
                                        slot: "append",
                                      })
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "生产日期", prop: "prodDate" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.report.prodDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.report, "prodDate", $$v)
                                  },
                                  expression: "report.prodDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Sample Source",
                                prop: "sampleSource",
                              },
                            },
                            [
                              _c("ic-select", {
                                attrs: {
                                  table: "TT_PROCESS_SENSORY",
                                  field: "SAMPLE_SOURCE",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.report.sampleSource,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.report, "sampleSource", $$v)
                                  },
                                  expression: "report.sampleSource",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("common.remarks"),
                                prop: "remark",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "handle-input",
                                attrs: {
                                  type: "textarea",
                                  clearable: "",
                                  maxlength: "200",
                                  disabled:
                                    _vm.disabled ||
                                    ["view"].includes(_vm.$route.query.type),
                                },
                                model: {
                                  value: _vm.report.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.report, "remark", $$v)
                                  },
                                  expression: "report.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "评估明细", name: "evaluationDetail" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.changeShow },
                    },
                    [_vm._v(_vm._s(_vm.isShow ? "隐藏标准" : "查看标准"))]
                  ),
                  !_vm.disabled &&
                  ["edit", "change"].includes(_vm.$route.query.type)
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.PROC_LOT_RECORD_ADD,
                              expression: "PROC_LOT_RECORD_ADD",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.onImport },
                        },
                        [_vm._v("导入")]
                      )
                    : _vm._e(),
                  !_vm.disabled &&
                  ["edit", "change"].includes(_vm.$route.query.type)
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.PROC_LOT_RECORD_ADD,
                              expression: "PROC_LOT_RECORD_ADD",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.onExport },
                        },
                        [_vm._v("导出")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "tableForm",
                  staticClass: "scoreTable",
                  staticStyle: { padding: "10px 0" },
                  attrs: { model: _vm.tableForm },
                },
                [
                  _c(
                    "el-table",
                    {
                      key: _vm.tableKey,
                      ref: "scoreTable",
                      attrs: {
                        data: _vm.tableForm.templateData,
                        "min-height": "500px",
                        "span-method": _vm.spanMethod,
                        border: "",
                        "row-class-name": _vm.rowClassNameFun,
                        "cell-class-name": _vm.cellClassNameFun,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "title",
                          label: "名称",
                          width: "160",
                          fixed: "",
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                      }),
                      _vm.isShow
                        ? _c("el-table-column", {
                            attrs: {
                              label: "标准",
                              "class-name": "template-detail",
                              "min-width": "380px",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.detailType == "TITLE"
                                        ? _c("div", [
                                            _vm._v(_vm._s(scope.row.detail)),
                                          ])
                                        : scope.row.detailType == "SCORE"
                                        ? _c("div", [
                                            _vm._v(_vm._s(scope.row.detail)),
                                          ])
                                        : _c("div", [
                                            scope.row.isComments == "Y"
                                              ? _c("div", [
                                                  _vm._v(
                                                    _vm._s(scope.row.detail)
                                                  ),
                                                ])
                                              : _vm._e(),
                                            scope.row.isComments != "Y"
                                              ? _c(
                                                  "div",
                                                  [
                                                    _vm._l(9, function (i) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: i + "1",
                                                          staticClass:
                                                            "template-detail-cell row1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row.detail.split(
                                                                "`"
                                                              )[i - 1] == ""
                                                                ? " 　"
                                                                : scope.row.detail.split(
                                                                    "`"
                                                                  )[i - 1]
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    }),
                                                    _vm._l(9, function (i) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: i + "2",
                                                          staticClass:
                                                            "template-detail-cell row2",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                scope.row
                                                                  .start > i ||
                                                                  scope.row
                                                                    .end < i
                                                                  ? " "
                                                                  : i
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }),
                                                  ],
                                                  2
                                                )
                                              : _vm._e(),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3824884879
                            ),
                          })
                        : _vm._e(),
                      _vm._l(
                        _vm.tableForm.tableHeadData,
                        function (batch, batchIndex) {
                          return _c("el-table-column", {
                            key: "ab" + batchIndex + _vm.initialKey,
                            attrs: {
                              "min-width": "300px",
                              align: "center",
                              "header-align": "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "table_header_grandFather",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "table_header_father",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "table_header_input",
                                                },
                                                [
                                                  batchIndex == 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "table_header_input_label",
                                                        },
                                                        [
                                                          _c("p", [
                                                            _vm._v("评估类型:"),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "'table_header_input_content1'",
                                                      staticStyle: {
                                                        width:
                                                          "calc(100% - 60px) !important",
                                                      },
                                                    },
                                                    [
                                                      _c("ic-select", {
                                                        staticStyle: {
                                                          width: "100%",
                                                          padding:
                                                            "0px!important",
                                                        },
                                                        attrs: {
                                                          table:
                                                            "TT_PROCESS_SENSORY",
                                                          field: "RATE_TYPE",
                                                          disabled: "",
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.tableForm
                                                              .tableHeadData[
                                                              batchIndex
                                                            ].rateType,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.tableForm
                                                                .tableHeadData[
                                                                batchIndex
                                                              ],
                                                              "rateType",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "tableForm.tableHeadData[batchIndex].rateType",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "table_header_input",
                                                },
                                                [
                                                  batchIndex == 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "table_header_input_label",
                                                        },
                                                        [
                                                          _c("p", [
                                                            _vm._v("批次号:"),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "'table_header_input_content1'",
                                                      staticStyle: {
                                                        width:
                                                          "calc(100% - 60px) !important",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "100%",
                                                          padding: "0px",
                                                        },
                                                        attrs: { disabled: "" },
                                                        model: {
                                                          value:
                                                            _vm.tableForm
                                                              .tableHeadData[
                                                              batchIndex
                                                            ].batchNoWithStatus,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.tableForm
                                                                .tableHeadData[
                                                                batchIndex
                                                              ],
                                                              "batchNoWithStatus",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "tableForm.tableHeadData[batchIndex].batchNoWithStatus",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.isShowMore,
                                                      expression: "isShowMore",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "table_header_input",
                                                },
                                                [
                                                  batchIndex == 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "table_header_input_label",
                                                        },
                                                        [
                                                          _c("p", [
                                                            _c("i", {
                                                              staticClass:
                                                                "mandatory",
                                                            }),
                                                            _vm._v("评估日期:"),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "'table_header_input_content1'",
                                                      staticStyle: {
                                                        width:
                                                          "calc(100% - 60px) !important",
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        key:
                                                          batchIndex +
                                                          _vm.initialKey,
                                                        staticStyle: {
                                                          width: "100%",
                                                          padding: "0px",
                                                        },
                                                        attrs: {
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          type: "date",
                                                          disabled:
                                                            _vm.disabled ||
                                                            ["view"].includes(
                                                              _vm.$route.query
                                                                .type
                                                            ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.rateDateChange(
                                                              _vm.tableForm
                                                                .tableHeadData[
                                                                batchIndex
                                                              ].rateDate,
                                                              batchIndex
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.tableForm
                                                              .tableHeadData[
                                                              batchIndex
                                                            ].rateDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.tableForm
                                                                .tableHeadData[
                                                                batchIndex
                                                              ],
                                                              "rateDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "tableForm.tableHeadData[batchIndex].rateDate",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.isShowMore,
                                                      expression: "isShowMore",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "table_header_input",
                                                },
                                                [
                                                  batchIndex == 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "table_header_input_label",
                                                        },
                                                        [
                                                          _c("p", [
                                                            _vm._v("保质期:"),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "'table_header_input_content1'",
                                                      staticStyle: {
                                                        width:
                                                          "calc(100% - 60px) !important",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        key:
                                                          batchIndex +
                                                          _vm.initialKey,
                                                        staticStyle: {
                                                          width: "100%",
                                                          padding: "0px",
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.disabled ||
                                                            ["view"].includes(
                                                              _vm.$route.query
                                                                .type
                                                            ),
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.tableForm
                                                              .tableHeadData[
                                                              batchIndex
                                                            ].expDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.tableForm
                                                                .tableHeadData[
                                                                batchIndex
                                                              ],
                                                              "expDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "tableForm.tableHeadData[batchIndex].expDate",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.isShowMore,
                                                      expression: "isShowMore",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "table_header_input",
                                                },
                                                [
                                                  batchIndex == 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "table_header_input_label",
                                                        },
                                                        [
                                                          _c("p", [
                                                            _vm._v("样品代码:"),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "'table_header_input_content1'",
                                                      staticStyle: {
                                                        width:
                                                          "calc(100% - 60px) !important",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        key:
                                                          batchIndex +
                                                          _vm.initialKey,
                                                        staticStyle: {
                                                          width: "100%",
                                                          padding: "0px",
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            _vm.disabled ||
                                                            ["view"].includes(
                                                              _vm.$route.query
                                                                .type
                                                            ),
                                                          type: "textarea",
                                                          maxlength: "200",
                                                          "show-word-limit": "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.tableForm
                                                              .tableHeadData[
                                                              batchIndex
                                                            ].sampleCode,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.tableForm
                                                                .tableHeadData[
                                                                batchIndex
                                                              ],
                                                              "sampleCode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "tableForm.tableHeadData[batchIndex].sampleCode",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c("i", {
                                            class: _vm.isShowMore
                                              ? "el-icon-arrow-up"
                                              : "el-icon-arrow-down",
                                            staticStyle: {
                                              color: "#f8ab01",
                                              display: "inline-block",
                                              width: "14px",
                                              height: "auto",
                                            },
                                            attrs: { circle: "" },
                                            on: { click: _vm.onShowMore },
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.detailType != "TITLE" &&
                                      scope.row.detailType != "SCORE" &&
                                      scope.row.isComments == "Y"
                                        ? _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                display: "inline-block",
                                                width: "60%",
                                              },
                                              attrs: {
                                                prop: `tableHeadData[${batchIndex}].scores[${scope.row.index}]`,
                                                rules: _vm.scoreRules.score2,
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  type: "textarea",
                                                  disabled:
                                                    _vm.disabled ||
                                                    ["view"].includes(
                                                      _vm.$route.query.type
                                                    ),
                                                  placeholder:
                                                    _vm.scoresPlaceholder(
                                                      _vm.disabled
                                                    ),
                                                },
                                                model: {
                                                  value:
                                                    batch.scores[
                                                      scope.row.index
                                                    ],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      batch.scores,
                                                      scope.row.index,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "batch.scores[scope.row.index]",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      scope.row.detailType != "TITLE" &&
                                      scope.row.detailType != "SCORE" &&
                                      scope.row.isComments != "Y"
                                        ? _c(
                                            "el-form-item",
                                            {
                                              staticStyle: {
                                                display: "inline-block",
                                                width: "60%",
                                              },
                                              attrs: {
                                                prop: `tableHeadData[${batchIndex}].scores[${scope.row.index}]`,
                                                rules: _vm.scoreRules.score,
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticClass: "score",
                                                attrs: {
                                                  max: scope.row.end,
                                                  min: scope.row.start,
                                                  disabled:
                                                    _vm.disabled ||
                                                    ["view"].includes(
                                                      _vm.$route.query.type
                                                    ),
                                                },
                                                model: {
                                                  value:
                                                    batch.scores[
                                                      scope.row.index
                                                    ],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      batch.scores,
                                                      scope.row.index,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "batch.scores[scope.row.index]",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      scope.row.detailType == "SCORE"
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.countScore(
                                                  scope.row.scoreField,
                                                  batch
                                                )
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        }
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "附件", name: "attachment" } },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { type: "border-card" },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "产品照片", name: "picture" } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "picture",
                          attrs: {
                            headers: _vm.header,
                            action: _vm.fileUploadUrl,
                            "file-list": _vm.picList,
                            "on-success": _vm.uploadSuccess,
                            accept:
                              ".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP",
                            disabled:
                              _vm.disabled ||
                              ["view"].includes(_vm.$route.query.type),
                            multiple: "",
                            "list-type": "picture-card",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "file",
                              fn: function ({ file }) {
                                return _c(
                                  "div",
                                  { staticStyle: { height: "100%" } },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        "max-width": "100%",
                                        height: "auto",
                                        "object-fit": "contain",
                                      },
                                      attrs: { src: file.url, alt: "" },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-actions",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-upload-list__item-preview",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handlePreview(file)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-zoom-in",
                                            }),
                                          ]
                                        ),
                                        file.tmDocumentId
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-list__item-delete",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.downloadFile(
                                                      file
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-download",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        !_vm.disabled &&
                                        ["edit", "change"].includes(
                                          _vm.$route.query.type
                                        )
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "el-upload-list__item-delete",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.fileRemove(file)
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-delete",
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              },
                            },
                          ]),
                        },
                        [_c("i", { staticClass: "el-icon-plus" })]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "产品附件", name: "file" } },
                    [
                      _c(
                        "el-row",
                        { staticStyle: { "margin-bottom": "10px" } },
                        [
                          !_vm.disabled &&
                          ["edit", "change"].includes(_vm.$route.query.type)
                            ? _c(
                                "el-upload",
                                {
                                  directives: [
                                    {
                                      name: "acl",
                                      rawName: "v-acl",
                                      value: _vm.PROC_LOT_RECORD_ADD,
                                      expression: "PROC_LOT_RECORD_ADD",
                                    },
                                  ],
                                  ref: "upload",
                                  attrs: {
                                    "show-file-list": false,
                                    headers: _vm.header,
                                    action: _vm.fileUploadUrl,
                                    "before-upload": _vm.beforeUpload,
                                    "on-success": _vm.uploadSuccess,
                                    multiple: true,
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "primary" } },
                                    [_vm._v(_vm._s(_vm.$t("common.upload")))]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.fileTableData,
                            border: "",
                            stripe: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "documentName", label: "附件" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadFile(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.documentName))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          !_vm.disabled &&
                          ["edit", "change"].includes(_vm.$route.query.type)
                            ? _c("el-table-column", {
                                attrs: { label: "操作", width: "180" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "small",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.delFile(
                                                    scope.row,
                                                    scope.$index,
                                                    "file"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-delete",
                                                staticStyle: { color: "red" },
                                              }),
                                              _vm._v("删除"),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3285947428
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "操作日志", name: "operationLog" } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.workFlowLogs, stripe: "", border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "createDate",
                      label: "操作时间",
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "operatorName",
                      label: "用户名称",
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "action", label: "操作" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "comments", label: "变更原因" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { "text-align": "center" },
          attrs: { visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            staticStyle: { height: "100%", width: "100%" },
            attrs: { src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "变更品评报告",
            visible: _vm.submitDialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.submitDialogVisible = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.changeForm,
                rules: _vm.changeFormRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选中单据", prop: "reportNo" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.changeForm.reportNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.changeForm, "reportNo", $$v)
                      },
                      expression: "changeForm.reportNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "变更原因", prop: "updateReason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 4 },
                      "show-word-limit": "",
                      maxlength: "1000",
                    },
                    model: {
                      value: _vm.changeForm.updateReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.changeForm, "updateReason", $$v)
                      },
                      expression: "changeForm.updateReason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", align: "middle", justify: "center" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("确定变更")]
              ),
              _c("el-button", { on: { click: _vm.onCancel } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量导入",
            visible: _vm.dialogBatchUploadVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogBatchUploadVisible = $event
            },
            close: _vm.onCloseUpload,
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-upload",
                {
                  ref: "batchUpload",
                  staticStyle: {
                    display: "inline-block",
                    "margin-right": "10px",
                  },
                  attrs: {
                    headers: _vm.header,
                    action: _vm.uploadListsUrl,
                    "on-success": _vm.uploadListsSuccess,
                    "on-error": _vm.uploadError,
                    "on-change": _vm.handleChange,
                    "before-upload": _vm.beforeListsUpload,
                    "file-list": _vm.fileList,
                    "auto-upload": false,
                    "show-file-list": false,
                  },
                },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small", type: "primary" } },
                    [_vm._v("选取文件")]
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  staticStyle: { height: "100%" },
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.onDownload },
                },
                [_vm._v("导入模板下载")]
              ),
            ],
            1
          ),
          _c(
            "el-form",
            { ref: "uploadForm", attrs: { model: _vm.uploadForm } },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.uploadForm.fileName,
                      callback: function ($$v) {
                        _vm.$set(_vm.uploadForm, "fileName", $$v)
                      },
                      expression: "uploadForm.fileName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-row", [
            _c("h4", [_vm._v("说明:")]),
            _c("ul", [
              _c("li", [_vm._v("1.请点击模板下载,按照模板填写后再上传")]),
              _c("li", [_vm._v("2.模板中红色字段为必填项,请务必正确填写")]),
              _c("li", [_vm._v("3.仅支持上传Excel格式文件,且大小不能超过20M")]),
              _c("li", [
                _vm._v("4.为保证上传成功,请勿对模板中的单元格进行修改"),
              ]),
              _c("li", [
                _vm._v("5.一次仅支持一份文件上传,多份文件上传将会替换原文件"),
              ]),
            ]),
          ]),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onUpload },
                },
                [_vm._v("上传")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onClose1 },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }